"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ButtonBase2 = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("@material-ui/core/utils");

var _Button = _interopRequireDefault(require("./Button.styles"));

var Button = /*#__PURE__*/(0, _react.forwardRef)(function Button(props, ref) {
  var _classNames;

  var children = props.children,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      fullWidth = props.fullWidth,
      variant = props.variant,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["children", "className", "color", "disabled", "fullWidth", "variant"]);
  var classes = (0, _Button.default)(); // ButtonBase to avoid having to override lots of styles

  return /*#__PURE__*/_react.default.createElement(_ButtonBase2.default, Object.assign({}, otherProps, {
    className: (0, _classnames.default)('pds-button', classes.root, classes[variant], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["".concat(variant).concat((0, _utils.capitalize)(color))], color !== 'blue'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className),
    disabled: disabled,
    ref: ref
  }), children);
});
Button.defaultProps = {
  color: 'blue',
  variant: 'primary'
};
Button.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.node,

  /**
   * The CSS class name to apply to the button or anchor node.
   */
  className: _propTypes.string,

  /**
   * The main color for the button.
   */
  color: (0, _propTypes.oneOf)(['blue', 'red']),

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes.bool,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.bool,

  /**
   * @ignore
   */
  onBlur: _propTypes.func,

  /**
   * @ignore
   */
  onClick: _propTypes.func,

  /**
   * @ignore
   */
  onDragLeave: _propTypes.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.func,

  /**
   * Used to control the button's purpose.
   * This prop passes the value to the `type` attribute of the native button component.
   */
  type: (0, _propTypes.oneOf)(['submit', 'reset', 'button']),

  /**
   * The button style, `primary` has a colored background, `secondary` has a white background with a
   * colored border and tertiary is all white and only the text has color.
   */
  variant: (0, _propTypes.oneOf)(['primary', 'secondary', 'tertiary'])
};
var _default = Button;
exports.default = _default;
